import React from "react";
//import { home } from "../../constants/clientRoutes"
//import { Link } from "react-router"
export default (props) =>
{
    return (
        <div className="Login_center_div">
            <div className="text-center">
                <h1>Obs!</h1>
            </div>
            <center>
                <h2>Beklager - vi finner ikke siden du spør etter.</h2>
                <h4>Lenken kan være feil, eller artikkelen kan være fjernet.</h4>
            </center>
        </div>
    );
}